import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda G.',
  location: 'Rosario, Santa Fe',
  text: 'Empecé con mucho miedo vendiendo a mis vecinos. Hoy ya tengo pedidos fijos todas las semanas. La planilla de costos me salvó la vida porque antes no sabía si ganaba o perdía plata. ¡Súper recomendado!',
  initials: 'MF',
  color: 'bg-burgundy-100 text-burgundy-700'
}, {
  name: 'Patricia L.',
  location: 'Córdoba Capital',
  text: 'A mis 52 años pensé que ya no podía empezar nada nuevo. Buscaba un ingreso extra y este libro me dio el paso a paso. Las recetas son un éxito total, salen súper húmedos. Ya me pagué la luz y el gas de este mes solo con los budines.',
  initials: 'PL',
  color: 'bg-gold-100 text-gold-700'
}, {
  name: 'Carolina M.',
  location: 'La Plata, Buenos Aires',
  text: 'Soy mamá soltera y necesitaba laburo desde casa para cuidar a mi nene. Empecé hace un mes y no puedo creer la respuesta de la gente. El módulo de cómo vender por WhatsApp es oro puro. Al toque conseguí mis primeros clientes.',
  initials: 'CM',
  color: 'bg-brown-100 text-brown-700'
}, {
  name: 'Silvia R.',
  location: 'Mendoza',
  text: 'Siempre cociné rico pero no tenía idea de cómo vender. La guía te explica todo tan fácil que da gusto. Ahora los fines de semana tengo la cocina a full y esa plata extra me da una tranquilidad hermosa.',
  initials: 'SR',
  color: 'bg-orange-100 text-orange-700'
}, {
  name: 'Verónica S.',
  location: 'Mar del Plata, Buenos Aires',
  text: 'Compré el libro con dudas pero me sorprendió. No es solo recetas, es un negocio armado. Las estrategias para fechas especiales me hicieron explotar las ventas el Día del Padre. ¡Gracias por esta oportunidad!',
  initials: 'VS',
  color: 'bg-red-100 text-red-700'
}];
export function Testimonials() {
  return <section className="py-20 bg-cream-50" data-id="element-263">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-264">
        <div className="text-center mb-16" data-id="element-265">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-brown-900 mb-4" data-id="element-266">
            Mujeres que ya están generando ingresos
            <br data-id="element-267" />
            desde sus cocinas
          </motion.h2>
          <p className="text-lg text-brown-800/80" data-id="element-268">
            Historias reales de emprendedoras argentinas
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-269">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white p-6 rounded-2xl shadow-sm border border-cream-200 flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-270">
              <div className="flex gap-1 mb-4" data-id="element-271">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-gold-500 text-gold-500" data-id="element-272" />)}
              </div>

              <p className="text-brown-800/90 italic mb-6 flex-grow" data-id="element-273">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-cream-100" data-id="element-274">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${t.color}`} data-id="element-275">
                  {t.initials}
                </div>
                <div data-id="element-276">
                  <p className="font-bold text-brown-900 text-sm" data-id="element-277">{t.name}</p>
                  <p className="text-xs text-brown-800/60" data-id="element-278">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}